export const HOME_SECTION_TYPES = {
  DOMINARAM: "dominaram",
  ORIGINALS: "originals_zinnes",
  EXCLUSIVES: "exclusive_projects",
  LATEST: "latest_releases",
  UPDATED: "last_updated_projects",
  MONTHLY_BATTLE: "monthly_battle",
  AUTHORS: "authors",
  COMPLETED: "completed_projects",
};

export const HOME_SECTIONS = [
  {
    id: "dominaram",
    type: "ranking",
    sectionType: HOME_SECTION_TYPES.DOMINARAM,
    responseKey: "dominaram",
    fallbackKeys: ["top15", "top10", "projects"],
    title: "Dominaram!",
    subtitle: "As historias que conquistaram o momento.",
    limit: 15,
    showViews: false,
  },
  { id: "banners-comerciais", type: "banner", title: "", subtitle: "" },
  {
    id: "originals",
    type: "editorial",
    sectionType: HOME_SECTION_TYPES.ORIGINALS,
    responseKey: "originals_zinnes",
    title: "Originais Zinnes",
    subtitle: "Obras feitas especialmente para você!",
  },
  { id: "banners-primary", type: "banner", title: "Banners", subtitle: "" },
  {
    id: "exclusives",
    type: "editorial",
    sectionType: HOME_SECTION_TYPES.EXCLUSIVES,
    responseKey: "exclusive_projects",
    fallbackKeys: ["exclusives", "projects"],
    title: "Exclusivos",
    subtitle: "Curadoria especial da Zinnes para descobrir algo fora do óbvio.",
    preserveOrder: true,
  },
  {
    id: "latest",
    type: "project",
    sectionType: HOME_SECTION_TYPES.LATEST,
    responseKey: "latest_releases",
    title: "Novos na Zinnes",
    subtitle: "Lançamentos mais recentes da plataforma.",
  },
  {
    id: "updated",
    type: "project",
    sectionType: HOME_SECTION_TYPES.UPDATED,
    responseKey: "last_updated_projects",
    title: "Atualizados",
    subtitle: "Fique por dentro das novidades.",
  },
  {
    id: "monthly-battle",
    type: "ranking",
    sectionType: HOME_SECTION_TYPES.MONTHLY_BATTLE,
    responseKey: "monthly_battle",
    fallbackKeys: ["projects"],
    title: "Batalha Mensal!",
    subtitle: "O top mensal por curtidas e comentários.",
    limit: 10,
    showViews: false,
  },
  { id: "banners-secondary", type: "banner", title: "Banners", subtitle: "" },
  {
    id: "authors",
    type: "authors",
    sectionType: HOME_SECTION_TYPES.AUTHORS,
    responseKey: "authors",
    title: "Autores em Alta",
    subtitle: "Os artistas mais aclamados da Zinnes.",
  },
  {
    id: "completed",
    type: "completed",
    sectionType: HOME_SECTION_TYPES.COMPLETED,
    responseKey: "completed_projects",
    fallbackKeys: ["projects"],
    title: "Do começo ao Fim!",
    subtitle: "Histórias finalizadas para maratonar sem esperar o próximo capítulo.",
    completedOnly: true,
  },
];

export function loadableHomeSections() {
  return HOME_SECTIONS.filter(section => section.sectionType);
}
